var exports = {
  "Yo": "copilotBadge__nvj-uY",
  "Lq": "loading__CTDU6m",
  "lY": "animation__HcHGcw",
  "a6": "assistive__19naHO",
};

module.exports = exports;
